import { useEffect, useState } from 'react';

import { LogisticFee, Fee } from '@zooplus/checkout-state';
import { P1, Anchor } from '@zooplus/ui-components';

import useCartTracking from '@hooks/use-adobe-tracking/use-cart-tracking';

import CartLogisticsFeesModal from './cart-logistics-fees-modal';
import styles from './cart-logistics-fees.module.scss';

type CartLogisticsFeesProps = {
  fee: Fee;
  logisticFee: LogisticFee;
};

const CartLogisticsFees = ({ fee, logisticFee }: CartLogisticsFeesProps) => {
  const [isOpen, setIsOpen] = useState(false);
  const { trackOverweightFee, trackOverweightFeeDetailsClick } = useCartTracking();

  const { name, formattedSubtotal } = fee;

  useEffect(() => {
    logisticFee && trackOverweightFee();
  }, [logisticFee, trackOverweightFee]);

  return (
    <div data-testid="overweight-fee" className={styles.logisticsFeeWrapper}>
      <Anchor
        onClick={() => {
          trackOverweightFeeDetailsClick();
          setIsOpen(true);
        }}
        className={styles.logisticFeeTitle}>
        {name}
      </Anchor>
      <P1 data-testid="overweight-value">{formattedSubtotal}</P1>
      <CartLogisticsFeesModal isModalOpen={isOpen} callback={setIsOpen} logisticFee={logisticFee} />
    </div>
  );
};

export default CartLogisticsFees;
